module.exports = __webpack_public_path__ + "img/mw.a4ce3330.jpg";